import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from "../../assets/invicta_logo.jpg"
const WatchInput = () => {
    const navigate = useNavigate()
    const [modelNumber, setModelNumber] = useState('')
    const [error, setError] = useState('')
    const handleSearch = () => {
        const value = String(modelNumber).trim()
        if (!value) {
            setError('Please enter a model number')
            return
        }
        setError('')
        localStorage.setItem('invicta-watch-no', value)
        navigate(`/watch-details/${value}`)
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch()
        }
    }
    return (
        <div className="w-screen h-screen bg-[#FEF20F] flex flex-col items-center justify-center relative overflow-hidden">
            {/* Logo */}
            {/* Center card */}
            <div className="flex flex-col items-center max-w-2xl mx-auto  w-full px-4 ">
                <div className="flex flex-col items-center justify-center mb-[100px]">
                    <img
                        src={logo}
                        alt="Invicta - Welcome to the world of Invicta"
                        className="w-[280px] md:w-[420px] h-auto object-contain"
                    />
                </div>
                <h2 className="text-2xl md:text-3xl text-black mb-2 tracking-wide self-start sm:ml-10">
                    INVICTA SPECS APPLICATION
                </h2>
                <div className="w-full max-w-xl bg-[#FEF20F] bg-opacity-40 border-4 border-[#f8d400] rounded-2xl px-3 py-3 pb-5 shadow-[0_8px_20px_rgba(0,0,0,0.08)] flex flex-col gap-5">
                    <div className="flex flex-col gap-3">
                        <label className="text-xs md:text-sm text-black tracking-wide ">
                            VIEW SINGLE SPECS:
                        </label>
                        <input
                            type="text"
                            className={`w-full h-[52px] bg-white border rounded-full px-6 text-lg text-gray-800  text-center outline-none placeholder:text-gray-400 ${error ? 'border-red-500' : 'border-transparent'}`}
                            value={modelNumber}
                            onChange={(e) => {
                                setModelNumber(e.target.value)
                                if (error) setError('')
                            }}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter model number"
                        />
                        {error && (
                            <span className="text-xs text-red-600 mt-1">
                                {error}
                            </span>
                        )}
                    </div>
                </div>
                <button
                    className="mt-8 w-full max-w-xl h-14 bg-gradient-to-b from-[#ff9800] via-[#f57c00] to-[#c85a00] rounded-2xl text-base md:text-lg font-semibold text-white tracking-wide shadow-[0_10px_18px_rgba(0,0,0,0.25)] hover:brightness-105 active:translate-y-px transition-transform"
                    onClick={handleSearch}
                    type="button"
                >
                    SEARCH
                </button>
            </div>
        </div>
    )
}
export default WatchInput